import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { AlertContextProvider } from "./context/AlertContext";
import AlertModalContextProvider from "context/AlertModalContext";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

// import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import ThemeSwitcherContextProvider from "context/ThemeSwitcherContextProvider";
import UserRestrictionProvider from "context/UserRestrictionsContext";
import { store } from "./store";
import GlobalModalsProvider from "context/GlobalModalsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CookiesProvider>
    <BrowserRouter>
      <Provider store={store}>
        <AlertContextProvider>
          <ThemeSwitcherContextProvider>
            <AlertModalContextProvider>
              <GlobalModalsProvider>
                <UserRestrictionProvider>
                  <App />
                </UserRestrictionProvider>
              </GlobalModalsProvider>
            </AlertModalContextProvider>
          </ThemeSwitcherContextProvider>
        </AlertContextProvider>
      </Provider>
    </BrowserRouter>
  </CookiesProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
